module.exports = __webpack_public_path__ + "img/download2.ba6b1eaf.svg";